import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import {
  TimerIcon,
  TimerLinesIcon,
  TimerControlIcon,
  ButtonUpDefaultIcon,
  ButtonUpHoverIcon,
  ButtonUpClickedIcon,
  ButtonDownDefaultIcon,
  ButtonDownHoverIcon,
  ButtonDownClickedIcon,
  StartDefaultIcon,
  StartHoverIcon,
  StartClickedIcon,
} from '../../../Icons';

const BUTTON_PRESS_INTERVAL = 1000;

export function TimerMain(props) {
  return (
    <Image className={props.className} src={TimerIcon} alt='timer-image' />
  );
}

export function TimerLines(props) {
  return (
    <div className={props.className}>
      <Image
        className={props.className}
        src={TimerLinesIcon}
        alt='timer-lines'
      />
    </div>
  );
}

export function TimerBase(props) {
  return (
    <Image
      className={props.className}
      src={TimerControlIcon}
      alt='timer-control-base'
    />
  );
}

export const BTN_STATUS = {
  DEFAULT: '',
  CLICK: 'CLICK',
  HOVER: 'HOVER',
  DISABLED: 'DISABLED',
};

const UP_BUTTON = {
  hover: ButtonUpHoverIcon,
  clicked: ButtonUpClickedIcon,
  default: ButtonUpDefaultIcon,
};

export function UpButton(props) {
  const onEvent = function (callback) {
    return function (event) {
      event.stopPropagation();
      callback();
    };
  };

  return (
    <Image
      className={props.className}
      onMouseEnter={onEvent(props.onMouseEnter)}
      onMouseDown={onEvent(props.onMouseDown)}
      onMouseLeave={onEvent(props.onMouseLeave)}
      onMouseUp={onEvent(props.onMouseUp)}
      src={getButtonImage(UP_BUTTON, props.status)}
      alt={props.status}
    />
  );
}

UpButton.propTypes = {
  /**
   * ClassName to set on Component
   */
  className: PropTypes.string,
  /**
   * Callback for onMouseEnter
   */
  onMouseEnter: PropTypes.func,
  /**
   * Callback for onMouseLeave
   */
  onMouseLeave: PropTypes.func,
  /**
   * Callback for onMouseUp
   */
  onMouseUp: PropTypes.func,
  /**
   * Callback for onMouseDown
   */
  onMouseDown: PropTypes.func,
  /**
   * Status of button
   */
  status: PropTypes.oneOf([
    BTN_STATUS.DEFAULT,
    BTN_STATUS.HOVER,
    BTN_STATUS.CLICK,
    BTN_STATUS.DISABLED,
  ]),
};

const DOWN_BUTTON = {
  hover: ButtonDownHoverIcon,
  clicked: ButtonDownClickedIcon,
  default: ButtonDownDefaultIcon,
};
export function DownButton(props) {
  const onEvent = function (callback) {
    return function (event) {
      event.stopPropagation();
      callback();
    };
  };

  return (
    <Image
      className={props.className}
      onMouseEnter={onEvent(props.onMouseEnter)}
      onMouseDown={onEvent(props.onMouseDown)}
      onMouseLeave={onEvent(props.onMouseLeave)}
      onMouseUp={onEvent(props.onMouseUp)}
      src={getButtonImage(DOWN_BUTTON, props.status)}
      alt={props.status}
    />
  );
}

DownButton.propTypes = UpButton.propTypes;

const START_BUTTON = {
  hover: StartHoverIcon,
  clicked: StartClickedIcon,
  default: StartDefaultIcon,
};

export function StartButton(props) {
  const onEvent = function (callback) {
    return function (event) {
      event.stopPropagation();
      callback();
    };
  };

  return (
    <Image
      className={props.className}
      onClick={onEvent(props.onClick)}
      onMouseEnter={onEvent(props.onMouseEnter)}
      onMouseDown={onEvent(props.onMouseDown)}
      onMouseLeave={onEvent(props.onMouseLeave)}
      onMouseUp={onEvent(props.onMouseUp)}
      src={getButtonImage(START_BUTTON, props.status)}
      alt={props.status}
    />
  );
}

StartButton.propTypes = {
  ...UpButton.PropTypes,
  /**
   * Callback for onClick
   */
  onClick: PropTypes.func,
};

function getButtonImage(buttonConfig, buttonStatus) {
  switch (buttonStatus) {
    case BTN_STATUS.HOVER:
      return buttonConfig.hover;
    case BTN_STATUS.CLICK:
    case BTN_STATUS.DISABLED:
      return buttonConfig.clicked;
    default:
      return buttonConfig.default;
  }
}
